/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../../helpers'
import {Formik, Form, FormikValues, Field} from 'formik'
import {StepperComponent} from '../../../assets/ts/components'

interface ICreateAccount {
  appName: string
  category: string
  framework: string
  dbName: string
  dbType: string
  nameOnCard: string
  cardNumber: string
  cardExpiryMonth: string
  cardExpiryYear: string
  cardCvv: string
  saveCard: string
}

const inits: ICreateAccount = {
  appName: '',
  category: '1',
  framework: '1',
  dbName: '',
  dbType: '1',
  nameOnCard: 'Max Doe',
  cardNumber: '4111 1111 1111 1111',
  cardExpiryMonth: '1',
  cardExpiryYear: '2025',
  cardCvv: '123',
  saveCard: '1',
}

// const createAppSchema = [
//   Yup.object({
//     appName: Yup.string().required().label('App name'),
//     category: Yup.string().required().label('Category'),
//   }),
//   Yup.object({
//     framework: Yup.string().required().label('Framework'),
//   }),
//   Yup.object({
//     dbName: Yup.string().required().label('Database name'),
//     dbType: Yup.string().required().label('Database engine'),
//   }),
//   Yup.object({
//     nameOnCard: Yup.string().required().label('Name'),
//     cardNumber: Yup.string().required().label('Card Number'),
//     cardExpiryMonth: Yup.string().required().label('Expiration Month'),
//     cardExpiryYear: Yup.string().required().label('Expiration Year'),
//     cardCvv: Yup.string().required().label('CVV'),
//   }),
// ]

const Main: FC = () => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  //const [currentSchema, setCurrentSchema] = useState(createAppSchema[0])
  const [initValues] = useState<ICreateAccount>(inits)

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }

    stepper.current.goPrev()

    //setCurrentSchema(createAppSchema[stepper.current.currentStepIndex - 1])
  }

  const submitStep = (values: ICreateAccount, actions: FormikValues) => {
    if (!stepper.current) {
      return
    }

    //setCurrentSchema(createAppSchema[stepper.current.currentStepIndex])

    if (stepper.current.currentStepIndex !== stepper.current.totatStepsNumber) {
      stepper.current.goNext()
    } else {
      stepper.current.goto(1)
      actions.resetForm()
    }
  }

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }

    loadStepper()
  }, [stepperRef])

  return (
    <div className='modal fade' id='kt_modal_create_app' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered mw-900px'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h2>Create App</h2>

            <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'>
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
            </div>
          </div>

          <div className='modal-body py-lg-10 px-lg-10'>
            <div
              ref={stepperRef}
              className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
              id='kt_modal_create_app_stepper'
            >
              <div className='d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px'>
                <div className='stepper-nav ps-lg-10'>
                  <div className='stepper-item current' data-kt-stepper-element='nav'>
                    <div className='stepper-line w-40px'></div>

                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>1</span>
                    </div>

                    <div className='stepper-label'>
                      <h3 className='stepper-title'>Start</h3>

                      <div className='stepper-desc'>Name your Event</div>
                    </div>
                  </div>

                  <div className='stepper-item' data-kt-stepper-element='nav'>
                    <div className='stepper-line w-40px'></div>

                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>2</span>
                    </div>

                    <div className='stepper-label'>
                      <h3 className='stepper-title'>Detail</h3>

                      <div className='stepper-desc'>Define your event detail</div>
                    </div>
                  </div>

                  <div className='stepper-item' data-kt-stepper-element='nav'>
                    <div className='stepper-line w-40px'></div>

                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>3</span>
                    </div>

                    <div className='stepper-label'>
                      <h3 className='stepper-title'>Appointment</h3>

                      <div className='stepper-desc'>Add Appointment details</div>
                    </div>
                  </div>

                  <div className='stepper-item' data-kt-stepper-element='nav'>
                    <div className='stepper-line w-40px'></div>

                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>4</span>
                    </div>

                    <div className='stepper-label'>
                      <h3 className='stepper-title'>Addon</h3>

                      <div className='stepper-desc'>Provide other details</div>
                    </div>
                  </div>

                  <div className='stepper-item' data-kt-stepper-element='nav'>
                    <div className='stepper-line w-40px'></div>

                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>5</span>
                    </div>

                    <div className='stepper-label'>
                      <h3 className='stepper-title'>Release</h3>

                      <div className='stepper-desc'>Review and Submit</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='flex-row-fluid py-lg-5 px-lg-15'>
                <Formik initialValues={initValues} onSubmit={submitStep}>
                  {() => (
                    <Form className='form' noValidate id='kt_modal_create_app_form'>
                      <div className='current' data-kt-stepper-element='content'>
                        <div className='w-100'>
                          <div className='fv-row mb-10'>
                            <label className='d-flex align-items-center fs-5 fw-bold mb-2'>
                              <span className='required'>Event Name</span>
                              <i
                                className='fas fa-exclamation-circle ms-2 fs-7'
                                data-bs-toggle='tooltip'
                                title='Specify your unique app name'
                              ></i>
                            </label>

                            <Field
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              name='appName1'
                              placeholder='นัดตรวจสุขภาพ'                           
                            />
                          </div>

                          <div className='fv-row mb-10'>
                            <label className='d-flex align-items-center fs-5 fw-bold mb-2'>
                              <span className='required'>Patient</span>
                              <i
                                className='fas fa-exclamation-circle ms-2 fs-7'
                                data-bs-toggle='tooltip'
                                title='Specify your unique app name'
                              ></i>
                            </label>

                            <Field
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              name='appName2'
                              placeholder='กภ.ภูวนัตถ์ (เก่ง)'                            
                            />
                          </div>

                          <div className='fv-row mb-10'>
                            <label className='d-flex align-items-center fs-5 fw-bold mb-2'>
                              <span className='required'>Assign to</span>
                              <i
                                className='fas fa-exclamation-circle ms-2 fs-7'
                                data-bs-toggle='tooltip'
                                title='Specify your unique app name'
                              ></i>
                            </label>

                            <Field
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              name='appName3'
                              placeholder='ปิกนิก'                             
                            />
                          </div>

                          <div className='fv-row mb-10'>
                            <label className='d-flex align-items-center fs-5 fw-bold mb-2'>
                              <span className='required'>Therapeutic type</span>
                              <i
                                className='fas fa-exclamation-circle ms-2 fs-7'
                                data-bs-toggle='tooltip'
                                title='Specify your unique app name'
                              ></i>
                            </label>

                            <Field
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              name='appName4'
                              placeholder='PT'
                              defaultValue=''
                            />
                          </div>
                        </div>
                      </div>

                      <div data-kt-stepper-element='content'>
                        <div className='w-100'>
                          <div className='fv-row mb-10'>
                            <label className='d-flex align-items-center fs-5 fw-bold mb-2'>
                              <span className='required'>Description</span>
                              <i
                                className='fas fa-exclamation-circle ms-2 fs-7'
                                data-bs-toggle='tooltip'
                                title='Specify your unique app name'
                              ></i>
                            </label>

                            {/* <Field
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                              name='appName'
                              placeholder=''
                              value='ตรวจร่างกาย xxxx'
                            /> */}

                            <textarea
                              className='form-control form-control-lg form-control-solid'
                              rows={10}
                              defaultValue='ตรวจร่างกาย xxxx'
                            ></textarea>
                          </div>
                          <div className='fv-row mb-10'>
                            <label className='d-flex align-items-center fs-5 fw-bold mb-2'>
                              <span>Upload files</span>
                            </label>
                            <input type='file'></input>
                          </div>
                        </div>
                      </div>

                      <div data-kt-stepper-element='content'>
                        <div className='w-100'>
                          <div className='d-flex flex-column mb-7 fv-row'>
                            <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                              <span className='required'>Location</span>
                              <i
                                className='fas fa-exclamation-circle ms-2 fs-7'
                                data-bs-toggle='tooltip'
                                title="Specify a card holder's name"
                              ></i>
                            </label>

                            <Field
                              type='text'
                              name='appName5'
                              className='form-control form-control-solid'
                              placeholder='รามอินทรา'                             
                            />
                          </div>
                          <div className='d-flex flex-column mb-7 fv-row'>
                            <label className='form-check form-check-custom form-check-solid'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                value=''
                                id='kt_calendar_datepicker_allday'
                              />
                              <span className='form-check-label fw-bold'>All Day</span>
                            </label>
                          </div>
                          {/* begin::Input group */}
                          <div className='row row-cols-lg-2 g-10'>
                            <div className='col'>
                              <div className='fv-row mb-9'>
                                {/* begin::Label */}
                                <label className='fs-6 fw-bold mb-2 required'>
                                  Event Start Date
                                </label>
                                {/* end::Label */}
                                {/* begin::Input */}
                                <input
                                  className='form-control form-control-solid'
                                  name='calendar_event_start_date'
                                  placeholder='Pick a start date'
                                  id='kt_calendar_datepicker_start_date'
                                  defaultValue='04/02/2022'
                                />
                                {/* end::Input */}
                              </div>
                            </div>
                            <div className='col' data-kt-calendar='datepicker'>
                              <div className='fv-row mb-9'>
                                {/* begin::Label */}
                                <label className='fs-6 fw-bold mb-2'>Event Start Time</label>
                                {/* end::Label */}
                                {/* begin::Input */}
                                <input
                                  className='form-control form-control-solid'
                                  name='calendar_event_start_time'
                                  placeholder='Pick a start time'
                                  id='kt_calendar_datepicker_start_time'
                                  defaultValue='03:00 PM'
                                />
                                {/* end::Input */}
                              </div>
                            </div>
                          </div>
                          {/* end::Input group */}
                          {/* begin::Input group */}
                          <div className='row row-cols-lg-2 g-10'>
                            <div className='col'>
                              <div className='fv-row mb-9'>
                                {/* begin::Label */}
                                <label className='fs-6 fw-bold mb-2 required'>Event End Date</label>
                                {/* end::Label */}
                                {/* begin::Input */}
                                <input
                                  className='form-control form-control-solid'
                                  name='calendar_event_end_date'
                                  placeholder='Pick a end date'
                                  id='kt_calendar_datepicker_end_date'
                                  defaultValue='04/02/2022'
                                />
                                {/* end::Input */}
                              </div>
                            </div>
                            <div className='col' data-kt-calendar='datepicker'>
                              <div className='fv-row mb-9'>
                                {/* begin::Label */}
                                <label className='fs-6 fw-bold mb-2'>Event End Time</label>
                                {/* end::Label */}
                                {/* begin::Input */}
                                <input
                                  className='form-control form-control-solid'
                                  name='calendar_event_end_time'
                                  placeholder='Pick a end time'
                                  id='kt_calendar_datepicker_end_time'
                                  defaultValue='06:00 PM'
                                />
                                {/* end::Input */}
                              </div>
                            </div>
                          </div>
                          {/* end::Input group */}
                        </div>
                      </div>

                      <div data-kt-stepper-element='content'>
                        <div className='w-100'>
                          <div className='d-flex flex-column mb-7 fv-row'>
                            <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                              <span className='required'>Package (6/10)</span>
                            </label>

                            <Field
                              type='text'
                              name='appName6'
                              className='form-control form-control-solid'
                              defaultValue='Health Care'
                      
                            />
                          </div>
                        </div>
                      </div>

                      <div data-kt-stepper-element='content'>
                        <div className='w-100 text-center'>
                          <h1 className='fw-bolder text-dark mb-3'>Release!</h1>
                          <div className='d-flex flex-column mb-7 fv-row'>
                            <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                              <span className='required'>Edit Name</span>
                            </label>

                            <Field
                              type='text'
                              name='appName7'
                              className='form-control form-control-solid'
                              defaultValue='กภ.ภูวนัตถ์ (เก่ง) PT นัดตรวจสุขภาพ...'
                            
                            />
                          </div>
                          <div className='d-flex flex-column mb-7 fv-row'>
                            <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                              <span>Event Name : นัดตรวจสุขภาพ </span>
                            </label>
                            <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                              <span>Patient : กภ.ภูวนัตถ์ (เก่ง) </span>
                            </label>
                            <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                              <span>Assign to : ปิกนิก </span>
                            </label>
                            <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                              <span>Therapeutic type : PT </span>
                            </label>
                            <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                              <span>Description: ตรวจร่างกาย xxxx </span>
                            </label>
                            <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                              <span>Location: รามอินทรา </span>
                            </label>
                            <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                              <span>Start Date: 02/04/2022 03:00 PM </span>
                            </label>
                            <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                              <span>End Date: 02/04/2022 04:30 PM </span>
                            </label>
                            <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                              <span>Package: Health care (6/10) </span>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className='d-flex flex-stack pt-10'>
                        <div className='me-2'>
                          <button
                            onClick={prevStep}
                            type='button'
                            className='btn btn-lg btn-light-primary me-3'
                            data-kt-stepper-action='previous'
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr063.svg'
                              className='svg-icon-4 me-1'
                            />
                            Back
                          </button>
                        </div>

                        <div>
                          <button type='submit' className='btn btn-lg btn-primary me-3'>
                            <span className='indicator-label'>
                              {stepper.current?.currentStepIndex !==
                                stepper.current?.totatStepsNumber! - 1 && 'Continue'}
                              {stepper.current?.currentStepIndex ===
                                stepper.current?.totatStepsNumber! - 1 && 'Submit'}
                              <KTSVG
                                path='/media/icons/duotune/arrows/arr064.svg'
                                className='svg-icon-3 ms-2 me-0'
                              />
                            </span>
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {Main}
